// extracted by mini-css-extract-plugin
module.exports = {"list":"GitLanguages_list__32aOV","langs":"GitLanguages_langs__345T3"};